// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2eb662db","459":"a320f120"}[chunkId] + ".chunk.js";
};